// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"251":"76e494cb","416":"d1314c0b","791":"43d6bf36"}[chunkId] + ".css";
};